import { PropertyApiItem } from '../api/types';
import { Site } from '../types/site.types';

/**
 * Transform API property item to Site format
 * @param apiItem - Property item from API
 * @returns Site object for UI
 */
export const transformPropertyToSite = (apiItem: PropertyApiItem): Site => {
  // Parse sales representative name
  // Assuming personInChargeName is in format "LastName FirstName"
  // Handle null/undefined values
  const personName = apiItem.personInChargeName || '';
  const nameParts = personName.trim().split(/\s+/).filter(Boolean);
  const lastName = nameParts[0] || '';
  const firstName = nameParts.slice(1).join(' ') || '';

  return {
    id: apiItem.id,
    propertyAbbreviation: apiItem.nameAbbreviation || '',
    constructionCompany: apiItem.constructionCompanyNameAbbreviation || '',
    salesRepresentative: {
      firstName,
      lastName,
    },
    lastUpdatedDate: apiItem.updatedAt || '',
    isArchived: apiItem.isArchive || false,
    createdAt: apiItem.createdAt || '',
    updatedAt: apiItem.updatedAt || '',
    // Note: The API doesn't return construction dates in the current schema
    // These would need to be added to the API or fetched separately
    constructionStartDate: '',
    constructionEndDate: '',
    readOnly: !apiItem.canUpdate,
  };
};

/**
 * Transform array of API property items to Sites
 * @param apiItems - Array of property items from API
 * @returns Array of Site objects for UI
 */
export const transformPropertiesToSites = (apiItems: PropertyApiItem[]): Site[] => {
  return apiItems.map(transformPropertyToSite);
};
